import { actions, selectors } from 'data'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const PollingProducts = () => {
  const isAuthenticated = useSelector(selectors.auth.isAuthenticated)
  const dispatch = useDispatch()
  useEffect(
    function watchForUserAuthenticated() {
      if (isAuthenticated) {
        dispatch(actions.eligibility.startPolling())
      } else {
        dispatch(actions.eligibility.stopPolling())
      }
    },
    [isAuthenticated]
  )

  return null
}

export default PollingProducts
